/**
 * Domain model for `/businesses/analytics/overview`.
 *
 * Reads BOTH camelCase (current BE wire format — class-transformer
 * @Expose decorators are not applied without a ClassSerializerInterceptor)
 * and snake_case (in case the BE adds the interceptor later). Either
 * shape is accepted, with camelCase taking priority.
 */

const pick = (obj, ...keys) => {
  for (const k of keys) {
    if (obj && obj[k] !== undefined) return obj[k];
  }
  return undefined;
};

const wrap = raw => ({
  value: raw?.value ?? 0,
  prev: raw?.prev
});

export class AnalyticsOverview {
  constructor(data = {}) {
    this.totalServices = wrap(pick(data, "totalServices", "total_services"));
    this.avgResponseTime = wrap(
      pick(data, "avgResponseTime", "avg_response_time")
    );
    this.avgRating = wrap(pick(data, "avgRating", "avg_rating"));
    this.completionRate = wrap(
      pick(data, "completionRate", "completion_rate")
    );
    this.uniqueDrivers = wrap(pick(data, "uniqueDrivers", "unique_drivers"));
    const sparks = data.sparks || {};
    this.sparks = {
      services: sparks.services || [],
      response: sparks.response || [],
      rating: sparks.rating || [],
      completion: sparks.completion || [],
      drivers: sparks.drivers || []
    };
  }
}
